import { httpClient } from '@/infra/protocols/http';
import { IPodcastConfiguration } from '@/modules/podcasts/entities/podcast-configuration.entity';
import { PodcastConfigurationMapper } from '@/modules/podcasts/mappers/podcast-configuration.mapper';

export async function configurePodcast(
  params: ConfigurePodcastService.Params,
  data: ConfigurePodcastService.Payload,
) {
  return httpClient.put(
    `/v1/projetos/${params.projectId}/podcasts/${params.podcastId}/configuracoes`,
    PodcastConfigurationMapper.toPersistence(data),
  );
}

export namespace ConfigurePodcastService {
  export interface Params {
    projectId: string;
    podcastId: string;
  }

  export type Payload = IPodcastConfiguration;
}
